import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const getZonasUrl = "api/v1/websalud/primeraars/catalogo/zonas";

const getProvinciasUrl = "api/v1/websalud/primeraars/catalogo/provincias";

const getDiagnosticosUrl = "api/v1/websalud/primeraars/catalogo/diagnosticos";

const getZonas = (request) =>
  InterceptToken(BaseApi.get, getZonasUrl, request).then(
    (response) => response.data
  );

const getProvincias = (request) =>
  InterceptToken(BaseApi.get, getProvinciasUrl, request).then(
    (response) => response.data
  );

const getDiagnosticos = () =>
  InterceptToken(BaseApi.get, getDiagnosticosUrl, null).then(
    (response) => response.data
  );

const exportedObject = {
  getZonas,
  getProvincias,
  getDiagnosticos,
};

export default exportedObject;
